// Libs
import React from 'react'

// CSS
import "./styles.scss"

const Attention = ({ children, ...rest }) => {
  return (
    <p className="attention" {...rest}>
      <span>ATENÇÃO</span> - {children}.
    </p>
  )
}

export default Attention
